"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const weavePlan_1 = require("../../../app/dist/weavePlan");
exports.toolDef = {
    name: 'loom_create_plan',
    description: 'Create a new plan document in a thread. **Write the plan in this same call** by passing `goal` (prose) + a structured `steps` array — each step is an object, never a hand-formatted Markdown table. Loom owns the steps table and the canonical `## Steps` columns; you supply the data and the plan is born frontmatter-native (the steps live in YAML frontmatter, the table is a generated view). Do NOT create a stub and immediately follow with loom_update_doc. Use this tool to create Loom plan docs — do not edit weave files directly.',
    inputSchema: {
        type: 'object',
        properties: {
            weave_slug: { type: 'string', description: 'Target weave folder slug' },
            thread_ulid: { type: 'string', description: 'Stable th_ ULID of the thread inside the weave' },
            title: { type: 'string', description: 'Optional plan title' },
            goal: { type: 'string', description: 'One paragraph: what this plan implements and why. Rendered as the body ## Goal section.' },
            steps: {
                type: 'array',
                description: 'Ordered structured steps. Each is an object — Loom renders the canonical table and per-step sections from these. Do NOT pass a Markdown table.',
                items: {
                    type: 'object',
                    properties: {
                        description: { type: 'string', description: 'The step, as it appears in the table "Step" cell.' },
                        title: { type: 'string', description: 'Optional short heading for the "### Step N — {title}" section (defaults to description).' },
                        files: { type: 'array', items: { type: 'string' }, description: 'Files this step touches ("Files touched" column).' },
                        blockedBy: { type: 'array', items: { type: 'string' }, description: 'Steps this step depends on. Each entry is a 1-based ordinal ("1","2") naming a sibling step by position, an existing step-id slug, or a cross-plan "pl_…" plan id. In this create call the generated slugs are not known yet, so reference siblings by ordinal ("1" = the first step). Do NOT invent "s1"-style ids — an unknown value is rejected, not silently stored.' },
                        satisfies: { type: 'array', items: { type: 'string' }, description: 'Requirement handles (IN/C) this step advances.' },
                        detail: { type: 'string', description: 'Optional markdown for the "### Step N" detail section (body prose, not persisted to frontmatter).' },
                    },
                    required: ['description'],
                },
            },
            parent_ulid: { type: 'string', description: 'Optional explicit parent doc ULID (defaults to thread design if present)' },
        },
        required: ['weave_slug', 'thread_ulid'],
    },
};
async function handle(root, args) {
    const input = {
        weaveSlug: args['weave_slug'],
        threadUlid: args['thread_ulid'],
        title: args['title'],
        goal: args['goal'],
        // Pass through unparsed — weavePlan's coerceSteps validates/parses at the
        // app boundary (a malformed call can deliver this JSON-encoded as a string).
        steps: args['steps'],
        parentUlid: args['parent_ulid'],
    };
    const result = await (0, weavePlan_1.weavePlan)(input, {
        loadWeave: dist_1.loadWeave,
        saveDoc: dist_1.saveDoc,
        loadDoc: dist_1.loadDoc,
        fs,
        loomRoot: root,
    });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
